<div class="absolute z-20 top-0 right-0 left-0 pl-5 pr-6 h-12 bg-green-500 w-full flex items-center justify-between font-bold">
    <div class="text-white">Order Details</div>
    <div>
        <p-button
            icon="pi pi-times" 
            [rounded]="true" 
            [text]="true" 
            (click)="closeDialog()"
            class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-md [&_.p-button-icon]:text-white" />
    </div>
</div>

<div class="py-16 flex flex-col gap-3">
    @if(userRole === 'shopper' && order.orderStatus === orderStatus.Delivered) {
        <p-message severity="success" icon="pi pi-face-smile" text="Thank you for being our shopping and delivery partner" styleClass="h-full" />
    } @else if(userRole === 'customer' && !utilitiesService.notificationsPermissionStatus?.granted) {
        <p-button
            (click)="getDevicePushToken()"
            [label]="'Turn On Order Updates Notifications'"
            [outlined]="true"
            [style]="{background: 'white'}"
            class="w-full [&_button]:w-full [&_button]:border-0 [&_button]:text-green-500" />
    }

    <p-timeline [value]="filteredEvents" layout="horizontal" styleClass="customized-timeline">
        <ng-template #marker let-event>
            <span class="flex min-w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm" [ngClass]="{ 'bg-green-500': event.completed, 'bg-green-50': !event.completed }">
                <i [class]="event.icon"></i>
            </span>
        </ng-template>
        <ng-template #content let-event>
            <span class="capitalize text-xs">{{ event.displayStatus }}</span>
        </ng-template>
    </p-timeline>
    <div class="flex justify-between">
        <div>
            <div class="text-xs text-gray-600">Order Number</div>
            <p class="text-sm font-medium">{{order.orderNumber}}</p>
        </div>
        <div class="text-right">
            <div class="text-xs text-gray-600">Order Status</div>
            <p class="text-sm capitalize text-green-500 font-medium">{{order.orderStatus}}</p>
        </div>
        
    </div>
   
    <div class="flex justify-between">
        <div>
            <div class="text-xs text-gray-600">Dropoff Address</div>
            @if(order.orderStatus !== orderStatus.Delivered || userRole === 'customer') {
                <p class="text-sm max-w-80 font-medium pr-5" (click)="openMaps()">{{order.deliveryLocation.fullAddress}} <i class="pi pi-external-link text-blue-400"></i></p>
            } @else {
                <p class="text-sm max-w-80 font-medium pr-5">{{order.deliveryLocation.city.name}}, {{order.deliveryLocation.state.name}}</p>
            }
        </div>
        <div class="text-right flex-none">
            <div class="text-xs text-gray-600">Order Date Time</div>
            <p class="text-sm font-medium">{{order.orderedDateTimeString | date: 'MMM d, y, h:mm a'}}</p>
        </div>
    </div>
    @if(userRole === 'customer') {
        <div class="flex justify-between">
            <div>
                @if(order.orderStatus === orderStatus.Delivered) {
                    <div class="text-xs text-gray-600">Delivery Date Time</div>
                    <p class="text-sm font-medium">{{order.deliveryDateTimeString | date: 'MMM d, y, h:mm a'}}</p>
                } @else {
                    <div class="text-xs text-gray-600">Delivery Window</div>
                    <p class="text-sm font-medium">{{order.estimatedDeliveryWindow}}</p>
                }
                
            </div>
            <div class="text-right">
                <div class="text-xs text-gray-600">Order Total</div>
                <p class="text-md font-medium font-bold text-green-500">{{order.total ? '$' + order.total : 'Items Cost + $' + (order.totalFee + ((order.tip || 0)*1)).toFixed(2)}}</p>
            </div>
        </div>
    } @else {
        @if(order.orderStatus === orderStatus.Delivered){
            <div class="flex justify-between">
                <div>
                    <div class="text-xs text-gray-600">Delivery Date Time</div>
                    <p class="text-sm font-medium">{{order.deliveryDateTimeString | date: 'MMM d, y, h:mm a'}}</p>
                </div>
                <div class="text-right">
                    <div class="text-xs text-gray-600">Your Pay</div>
                    <p class="text-md font-medium font-bold text-green-500">${{((order.totalDeliveryFee*1) + (order.totalShoppingFee*1) + (order.tip*1)).toFixed(2)}}</p>
                </div>
            </div>
        } @else {
            <div class="flex justify-between">
                <div>
                    <div class="text-xs text-gray-600">Customer Name</div>
                    <p class="text-sm font-medium">{{order.createdByName}}</p>
                </div>
                <div class="text-right">
                    <div class="text-xs text-gray-600">Delivery Window</div>
                    <p class="text-sm font-bold">{{order.estimatedDeliveryWindow}}</p>
                </div>
            </div>
        }
    }
     @if(userRole === 'customer') {
        <div class="flex justify-between">
            <div class="">
                <div class="text-xs text-gray-600">Payment Status</div>
                <p class="text-sm capitalize font-medium">{{order.PaymentStatus}}</p>
            </div>
            <div class="text-right">
                <div class="text-xs text-gray-600">Payment Method</div>
                <p class="text-sm font-medium">{{'Card ending in ' + order.paymentMethodDetails?.card?.last4}}</p>
            </div>
        </div>
    }

    <!-- Shopping List -->
    <div class="p-4 border border-green-700 rounded-md flex flex-col gap-2">
        <div class="text-xs text-gray-600">Shopping List</div>
        @if(userRole === 'shopper') {
            <p-message severity="success" size="small">
                Customer Preferences: <br/>
                Preferred Stores: {{order.customerPreferences.favoriteStores || 'Not Specified'}}<br/>
                Preferred Grocery Variants: {{order.customerPreferences.organicVarient || 'Not Specified'}}
            </p-message>
        }
        
        @for (keyValuePair of groupedItems | keyvalue; track keyValuePair) {
            <div class="pb-3">
                <div class="text-md capitalize">{{keyValuePair.key || 'Any Store'}}, {{keyValuePair.value[0].location || 'Any Location'}}</div>
                @for (item of keyValuePair.value; track item.id) {
                    <div class="p-3 border-bottom-1 border-gray-300 flex flex-row justify-content-between">
                        <div class="flex-1">
                            <div class="font-medium text-sm"><span class="capitalize">{{ item.name }}</span></div>
                            <div class="text-sm font-light capitalize">@if(item.quantity){<span>{{item.quantity + ' ' + item.unit}}</span>}</div>
                            @if(item.notes) {<div class="text-sm font-light capitalize">{{item.notes}}</div>}
                            @if(item.images?.length) {
                                <div class="flex flex-wrap gap-2 mt-2">
                                    @for(image of item.images; track $index; let i = $index) {
                                        <p-image [imageStyle]="{'border-radius': '8px', 'width': '60px', 'height': '60px'}" [src]="image?.downloadUrl" alt="Image" width="60" height="60" [preview]="true" />
                                    }
                                </div>
                            }
                        </div>
                            <div class="flex gap-2">
                                <p-button
                                    icon="pi pi-check" 
                                    severity="success"
                                    [size]="'small'"
                                    [rounded]="true"
                                    [outlined]="item.status === 'found' ? false : true"
                                    class="[&_button]:opacity-100 [&_button]:w-6 [&_button]:h-6 [&_button]:border-green-500"/>
                                <p-button
                                    icon="pi pi-arrow-right-arrow-left" 
                                    severity="warn"
                                    [size]="'small'"
                                    [rounded]="true"
                                    [outlined]="item.status === 'replaced' ? false : true"
                                    class="[&_button]:opacity-100 [&_button]:w-6 [&_button]:h-6 [&_button]:border-orange-500"/>
                                <p-button
                                    icon="pi pi-ban" 
                                    severity="danger"
                                    [size]="'small'"
                                    [rounded]="true"
                                    [outlined]="item.status === 'not_found' ? false : true"
                                    class="[&_button]:opacity-100 [&_button]:w-6 [&_button]:h-6 [&_button]:border-red-500"/>
                            </div>
                        
                    </div>
                }
            </div>
        }
    </div> 

    <!-- Cost Breakdown for customers -->
    @if(userRole === 'customer') {
        <div class="p-4 border border-green-700 rounded-md flex flex-col gap-2">
            <div class="text-xs text-gray-600">Cost Breakdown</div>
            <div class="flex justify-between">
                <div>
                    <div class="text-xs text-gray-600">Items Cost</div>
                    <p class="text-sm font-medium">{{(order.storeReceipts || []).length > 0 ? '$' + itemsCost(order.storeReceipts || []).toFixed(2) : 'Store Receipt'}}</p>
                </div>
                <div class="text-right">
                    <div class="text-xs text-gray-600">Shopping Fee</div>
                    <p class="text-sm font-medium">${{order.totalShoppingFee.toFixed(2)}}</p>
                </div>
            </div>
            <div class="flex justify-between">
                <div>
                    <div class="text-xs text-gray-600">Delivery Fee</div>
                    <p class="text-sm font-medium">${{order.totalDeliveryFee.toFixed(2)}}</p>
                </div>
                <div class="text-right">
                    <div class="text-xs text-gray-600">Platform Fee</div>
                    <p class="text-sm font-medium">${{order.serviceFee.toFixed(2)}}</p>
                </div>
            </div>
            <div class="flex justify-between">
                <div class="">
                    <div class="text-xs text-gray-600">Tip</div>
                    <p class="text-sm font-medium">${{order.tip.toFixed(2)}}</p>
                </div>
                <div class="text-right">
                    <div class="text-xs text-gray-600">Total Cost</div>
                    <p class="text-md font-medium font-bold">{{order.total ? '$' + order.total : 'Items Cost + $' + (order.totalFee + ((order.tip || 0)*1)).toFixed(2)}}</p>
                </div>
            </div>
        </div>
        @if(order.orderStatus === orderStatus.ShoppingCompleted || order.orderStatus === orderStatus.OnTheWay || order.orderStatus === orderStatus.Delivered) {
            <div class="p-4 border border-green-700 rounded-md flex flex-col gap-2">
                <div class="text-xs text-gray-600">Store Receipts</div>
                <div class="flex flex-wrap gap-2 my-2">
                    @for (image of order.storeReceipts; track $index; let i = $index) {
                        <p-image [imageStyle]="{'border-radius': '8px', 'width': '200px', 'height': '200px'}" [src]="image.receiptImage?.downloadUrl" alt="Image" width="200" height="200" [preview]="true" />
                    }
                </div>
            </div>
        }
        @if(order.orderStatus === orderStatus.Delivered) {
            <div class="p-4 border border-green-700 rounded-md flex flex-col gap-2">
                <div class="text-xs text-gray-600">Proof of Delivery</div>
                <div class="flex flex-wrap gap-2 my-2">
                    @for (image of order.proofOfDeliveryImages; track $index; let i = $index) {
                        <p-image [imageStyle]="{'border-radius': '8px', 'width': '200px', 'height': '200px'}" [src]="image.downloadUrl" alt="Image" width="200" height="200" [preview]="true" />
                    }
                </div>
            </div>
        }

        <p-message severity="success" icon="pi pi-face-smile" text="Thank you for trusting us with your grocery delivery needs" styleClass="h-full" />

    }

    <!-- Earning for shopper -->
    @if(userRole === 'shopper' && order.orderStatus === orderStatus.Delivered) {
        <!-- // TODO: Show Earnings -->
        <div class="p-4 border border-green-700 rounded-md flex flex-col gap-2">
            <div class="text-xs text-gray-600">Pay Breakdown</div>
            <div class="flex justify-between">
                <div>
                    <div class="text-xs text-gray-600">Delivery Pay</div>
                    <p class="text-sm font-medium">${{order.totalDeliveryFee.toFixed(2)}}</p>
                </div>
                <div class="text-right">
                    <div class="text-xs text-gray-600">Shopping Pay</div>
                    <p class="text-sm font-medium">${{order.totalShoppingFee.toFixed(2)}}</p>
                </div>
            </div>
            <div class="flex justify-between">
                <div>
                    <div class="text-xs text-gray-600">Tip</div>
                    <p class="text-sm font-medium">${{order.tip.toFixed(2)}}</p>
                </div>
                <div class="text-right">
                    <div class="text-xs text-gray-600">Total Pay</div>
                    <p class="text-md font-medium text-green-500 font-bold">${{((order.totalDeliveryFee*1) + (order.totalShoppingFee*1) + (order.tip*1)).toFixed(2)}}</p>
                </div>
            </div>
        </div>

        <div class="p-4 border border-green-700 rounded-md flex flex-col gap-2">
            <div class="text-xs text-gray-600">Store Receipts</div>
            <div class="flex flex-wrap gap-2 my-2">
                @for (image of order.storeReceipts; track $index; let i = $index) {
                    <p-image [imageStyle]="{'border-radius': '8px', 'width': '200px', 'height': '200px'}" [src]="image.receiptImage?.downloadUrl" alt="Image" width="200" height="200" [preview]="true" />
                }
            </div>
        </div>

        <div class="p-4 border border-green-700 rounded-md flex flex-col gap-2">
            <div class="text-xs text-gray-600">Proof of Delivery</div>
            <div class="flex flex-wrap gap-2 my-2">
                @for (image of order.proofOfDeliveryImages; track $index; let i = $index) {
                    <p-image [imageStyle]="{'border-radius': '8px', 'width': '200px', 'height': '200px'}"  [src]="image.downloadUrl" alt="Image" width="200" height="200" [preview]="true" />
                }
            </div>
        </div>

    }
</div>
<p-confirmdialog key="itemsConfirmDialog" [position]="'bottom'"/>